function RefineSearchTimeController(
  $scope,
  moment,
  urlService,
  timezoneService
) {
  $scope.filters = $scope.filterSet.filters;
  $scope.skipConversion = false;

  $scope.toggleTbd = () => {
    $scope.isTbd = !$scope.isTbd;
    $scope.filterSet.getFilter('tbd').changeValue($scope.isTbd);
    $scope.filterSet
      .getFilter('sortOrder')
      .changeValue($scope.isTbd ? 'created' : 'time');
  };

  $scope.$watch('filters.tbd.value', value => {
    $scope.isTbd = value;
  });

  $scope.$watch('filters.sortOrder.value', value => {
    $scope.isTimeBased = value === 'time';
  });

  $scope.$watch('endTime', (newVal, oldVal) => {
    if (!oldVal && newVal && !$scope.skipConversion) {
      const newDate = new Date(
        new Date(newVal).toLocaleString('en-US', {
          timeZone: timezoneService.userTimezone
        })
      ).getTime();

      $scope.endTime = newDate;
    }
  });


  $scope.$watchGroup(
    ['filters.startDate.value', 'filters.endDate.value'],
    (newTimeValues, previousTimeValues) => {
      const startFilterValue = $scope.filterSet.getFilterValue('startDate')
        ? urlService.getEpochTime(
          $scope.filterSet.getFilter('startDate').value
        ) * 1000
        : null;

      const endFilterValue = $scope.filterSet.getFilterValue('endDate')
        ? urlService.getEpochTime($scope.filterSet.getFilter('endDate').value) *
      1000
        : null;

      if ($scope.filterSet.getFilterValue('startDate') && timezoneService.isRelativeDate($scope.filterSet.getFilter('startDate').value)) {
        $scope.startTime = timezoneService.getRelativeDate($scope.filterSet.getFilter('startDate').value);
      } else {
        $scope.startTime = timezoneService.getTzDate(startFilterValue);
      }


      if (endFilterValue) {
        if (timezoneService.isRelativeDate($scope.filterSet.getFilter('endDate').value)) {
          $scope.endTime = timezoneService.getRelativeDate($scope.filterSet.getFilter('endDate').value);
        } else {
          $scope.endTime = timezoneService.getTzDate(endFilterValue);
        }
      }

      const oldEndTime = previousTimeValues[1];
      const newEndTime = newTimeValues[1];
      const newStartTime = newTimeValues[0];

      if (timezoneService.isFromQuickPick(newStartTime)) {
        $scope.skipConversion = true;
        $scope.startTime = timezoneService.getTzDate(startFilterValue);
      }

      if (timezoneService.isFromQuickPick(newEndTime)) {
        $scope.skipConversion = true;
        $scope.endTime = timezoneService.getTzDate(endFilterValue);
      } else if ((oldEndTime && oldEndTime !== 'empty') || endFilterValue) {
        // Do not update the time if it was just initialized by the timepicker
        $scope.skipConversion = true;
      }
      // ensure that initializing the time by selecting a time in the timepicker
      // respects global settings time setting
      if ((!oldEndTime || oldEndTime === 'empty') && (!newEndTime || newEndTime === 'empty')) {
        $scope.skipConversion = false;
      }
    }
  );

  $scope.setStartDate = (time, setAsDay) => {
    $scope.filterSet
      .getFilter('startDate')
      .changeValue(setAsDay ? time : timezoneService.getTzDiffDate(time) / 1000);
  };

  $scope.setEndDate = (time, setAsDay) => {
    $scope.filterSet
      .getFilter('endDate')
      .changeValue(setAsDay ? time : timezoneService.getTzDiffDate(time) / 1000);
  };
}

const ctrlArr = [
  '$scope',
  'moment',
  'urlService',
  'timezoneService',
  RefineSearchTimeController
];

export default function (ngModule) {
  ngModule.controller('RefineSearchTimeController', ctrlArr);
}
